import React from "react";
import { Helmet } from "react-helmet-async";

const RefundPolicy = () => {
  return (
    <>
      {/* 🔥 SEO META TAGS */}
      <Helmet>
        <title>Refund & Return Policy | LushDesire.in – Safe & Discreet Shopping</title>

        <meta
          name="description"
          content="Read LushDesire.in Refund Policy. Learn about our no-return policy, damaged product refunds, and secure refund process for sex toys in India."
        />

        <meta
          name="keywords"
          content="LushDesire refund policy, sex toys refund India, adult toys return policy, discreet shopping India, no return sex toys India"
        />

        <link rel="canonical" href="https://lushdesire.in/refund-policy" />

        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* 🔥 PAGE CONTENT */}
      <div
        className="legal-page"
        style={{
          backgroundColor: "#FFF5F5",
          padding: "90px 20px 60px", // navbar space
          minHeight: "100vh",
        }}
      >
        <div style={{ maxWidth: "900px", margin: "auto" }}>
          
          {/* ✅ MAIN H1 */}
          <h1 style={{ color: "#A61325", marginBottom: "20px" }}>
            Refund & Return Policy – LushDesire.in
          </h1>

          <p>
            At <strong>LushDesire</strong>, customer safety, hygiene, and privacy
            are our top priorities. Due to the personal and intimate nature of
            our products, we follow a transparent and strict refund policy for
            all orders placed on <strong>LushDesire.in</strong>.
          </p>

          {/* ✅ H2 */}
          <h2>No Return Policy</h2>
          <p>
            For hygiene and safety reasons, we do <strong>not</strong> accept
            returns or exchanges once a product has been delivered. This policy
            applies to all personal wellness and adult products sold on our
            platform.
          </p>

          {/* ✅ H2 */}
          <h2>Damaged or Incorrect Product</h2>
          <p>
            In the rare event that you receive a damaged, defective, or
            incorrect item, please contact our customer support team within
            <strong> 24 hours</strong> of delivery. You must provide clear
            images or an unboxing video as proof for verification.
          </p>

          {/* ✅ H2 */}
          <h2>Refund Approval Process</h2>
          <p>
            Once your request is reviewed and approved, the refund will be
            initiated. Approved refunds are processed within
            <strong> 5–7 business days</strong> to the original payment method
            used during checkout.
          </p>

          {/* ✅ H2 */}
          <h2>Discreet & Secure Shopping Assurance</h2>
          <p>
            LushDesire ensures <strong>100% discreet packaging</strong> and
            secure transactions for all customers across India. Your privacy
            is protected at every stage — from order placement to delivery.
          </p>

          {/* ✅ H2 */}
          <h2>Contact Support</h2>
          <p>
            For any refund-related queries, please reach out to our support
            team through the <strong>Contact Us</strong> page. Our team is
            always ready to assist you with transparency and care.
          </p>

        </div>
      </div>
    </>
  );
};

export default RefundPolicy;
